import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { resetReceipt, markReceiptDeleted } from '../redux/receipt';
import { HighlightOffOutlined } from '@material-ui/icons';

const receiptDisplayWrapperStyle = { display: 'flex', flexDirection: 'column', marginLeft: 'auto' };
const receiptDisplayStyle = { display: 'flex', alignItems: 'center', columnGap: '4px', marginLeft: 'auto' };
const deleteIconStyle = { cursor: 'pointer', color: 'red' };
const fileNameStyle = { overflow: 'hidden', overflowWrap: 'break-word' };
const receiptMsg = { fontSize: '.8em', textAlign: 'right' };

const ReceiptDisplay = () => {
    const dispatch = useDispatch();
    const { receipt: receiptFromStore, loading, analyzeError, validationError, markDeleted } = useSelector((state) => state.receipt);
    const entryFileName = useSelector((state) => state.entry?.attFileName);// file name from SQL

    const onRemove = () => {
        dispatch(resetReceipt());
    };
    const onMarkDeleted = () => {
        if (!markDeleted)//if it's already marked as deleted, dont mark it again
            dispatch(markReceiptDeleted());
    };

    return (
        <>
            {!receiptFromStore && entryFileName && (
                <div className="post2-receipt-display-wrapper" style={receiptDisplayWrapperStyle}>
                    <div className="post2-receipt-display" style={receiptDisplayStyle}>
                        <span style={markDeleted ? { ...fileNameStyle, textDecoration: 'line-through' } : fileNameStyle}>
                            {entryFileName}
                        </span>
                        <HighlightOffOutlined onClick={onMarkDeleted} fontSize="default" style={deleteIconStyle} />
                    </div>
                </div>
            )}
            {receiptFromStore && (
                <div className="post2-receipt-display-wrapper" style={receiptDisplayWrapperStyle}>
                    <div className="post2-receipt-display" style={receiptDisplayStyle}>
                        <span style={fileNameStyle}>{receiptFromStore.file.name}</span>
                        <HighlightOffOutlined onClick={onRemove} fontSize="default" style={deleteIconStyle} titleAccess='Remove' />
                    </div>
                    {loading && (
                        <div style={receiptMsg}>
                            <span>Saving you some typing, scanning for totals and dates...</span>
                        </div>
                    )}
                    {analyzeError && (
                        <div className="post2-receipt-analyze-error" style={{ ...receiptMsg, color: '#ff0000' }}>Receipt analysis error. Please try again. --- {analyzeError}</div>
                    )}
                    {validationError && (
                        <div className="post2-receipt-validation-error" style={{ ...receiptMsg, color: '#ff0000' }}>{validationError}</div>
                    )}
                </div>
            )}
        </>
    )
};

export default ReceiptDisplay;
